import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-918fd8b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"width":"90%","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","margin-top":"10rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/myinvois/images/Error Page Image.png",
  alt: "Logo",
  style: {"width":"40rem","margin":"1rem"}
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "error-box" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"0"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  style: {"margin-bottom":"0"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_10 = { style: {"font-weight":"bold"} }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_13 = { class: "header-container" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("E-Invoice "),
  /*#__PURE__*/_createElementVNode("br", { class: "mobile-next" }),
  /*#__PURE__*/_createTextVNode(" Submission Form ")
], -1 /* HOISTED */))
const _hoisted_16 = { class: "form-container" }
const _hoisted_17 = {
  key: 0,
  style: {"background-color":"#e4e4e4"},
  class: "rounded"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;justify-content:center;margin-top:20px;\" data-v-918fd8b0><svg width=\"40px\" height=\"40px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-918fd8b0><path opacity=\"0.5\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z\" fill=\"#008000\" data-v-918fd8b0></path><path d=\"M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z\" fill=\"#ffffff\" data-v-918fd8b0></path></svg></div><p style=\"text-align:center;font-size:14px;font-weight:bold;justify-content:center;margin:8px;\" data-v-918fd8b0> Congratulations! Your E-Invoice request has been successfully submitted. </p>", 2)
const _hoisted_20 = [
  _hoisted_18
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */))
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pos_invoice_no" }, [
  /*#__PURE__*/_createTextVNode("POS Invoice No "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "unstyled",
  for: "date"
}, [
  /*#__PURE__*/_createTextVNode("Transaction Date (YYYY-MM-DD)"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "store_name" }, [
  /*#__PURE__*/_createTextVNode("Store Name "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  width: "100%",
  size: "4",
  noshade: ""
}, null, -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"medium","font-weight":"bold","margin-bottom":"20px"} }, "PERSONAL DETAILS"),
  /*#__PURE__*/_createElementVNode("p")
], -1 /* HOISTED */))
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "full_name" }, [
  /*#__PURE__*/_createTextVNode("Full Name (as per ID) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email_address" }, [
  /*#__PURE__*/_createTextVNode("Email Address "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_37 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone_number" }, [
  /*#__PURE__*/_createTextVNode("Phone Number "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_42 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer_type" }, "Claim as:", -1 /* HOISTED */))
const _hoisted_44 = { style: {"display":"flex","align-items":"center","gap":"25px"} }
const _hoisted_45 = {
  class: "form-check",
  style: {"display":"flex"}
}
const _hoisted_46 = ["disabled", "checked"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "individual",
  style: {"cursor":"pointer"}
}, " Individual ", -1 /* HOISTED */))
const _hoisted_48 = {
  class: "form-check",
  style: {"display":"flex"}
}
const _hoisted_49 = ["disabled", "checked"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "company",
  style: {"cursor":"pointer"}
}, " Company ", -1 /* HOISTED */))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */))
const _hoisted_52 = {
  key: 0,
  width: "100%",
  size: "4",
  noshade: ""
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"medium","font-weight":"bold","margin-bottom":"20px"} }, "INDIVIDUAL DETAILS", -1 /* HOISTED */))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "individual-type" }, [
  /*#__PURE__*/_createTextVNode("Individual ID "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_57 = { style: {"display":"flex","align-items":"center","gap":"15px","margin-bottom":"10px"} }
const _hoisted_58 = {
  class: "form-check",
  style: {"display":"flex"}
}
const _hoisted_59 = ["disabled", "checked"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "NRIC",
  style: {"cursor":"pointer"}
}, " MyKad ", -1 /* HOISTED */))
const _hoisted_61 = {
  class: "form-check",
  style: {"display":"flex"}
}
const _hoisted_62 = ["disabled", "checked"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Passport",
  style: {"cursor":"pointer"}
}, " Passport ", -1 /* HOISTED */))
const _hoisted_64 = {
  class: "form-check",
  style: {"display":"flex"}
}
const _hoisted_65 = ["disabled", "checked"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Army",
  style: {"cursor":"pointer"}
}, " MyTentera ", -1 /* HOISTED */))
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = ["placeholder", "required", "disabled"]
const _hoisted_69 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_70 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_71 = {
  class: "form-group",
  style: {"margin-bottom":"10px"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tax_id" }, [
  /*#__PURE__*/_createTextVNode("Individual Tax Identification Number (TIN) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_73 = ["disabled"]
const _hoisted_74 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_75 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_76 = { key: 2 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"medium","font-weight":"bold","margin-bottom":"20px"} }, "COMPANY DETAILS", -1 /* HOISTED */))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */))
const _hoisted_79 = {
  class: "form-group",
  style: {"margin-bottom":"10px"}
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company-name" }, [
  /*#__PURE__*/_createTextVNode("Company Name "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  class: "form-group",
  style: {"margin-bottom":"10px"}
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company-id" }, [
  /*#__PURE__*/_createTextVNode("Company ID - Business Registration Number (BRN) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_86 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_87 = {
  class: "form-group",
  style: {"margin-bottom":"10px"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tax_id" }, [
  /*#__PURE__*/_createTextVNode("Company Tax Identification Number (TIN) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_89 = ["disabled"]
const _hoisted_90 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_91 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_92 = {
  class: "form-group",
  style: {"margin-bottom":"10px"}
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sst_registration_no" }, "SST Registration Number (Mandatory for SST-registrant)", -1 /* HOISTED */))
const _hoisted_94 = ["disabled"]
const _hoisted_95 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_96 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, [
  /*#__PURE__*/_createTextVNode("Address Line 1 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address Line 2 ", -1 /* HOISTED */))
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { class: "form-group" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, [
  /*#__PURE__*/_createTextVNode("Country "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_105 = {
  key: 3,
  class: "form-group"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, [
  /*#__PURE__*/_createTextVNode("State "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_107 = { class: "form-group" }
const _hoisted_108 = {
  key: 0,
  for: "city"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1 /* HOISTED */))
const _hoisted_110 = ["disabled"]
const _hoisted_111 = ["value"]
const _hoisted_112 = {
  key: 2,
  type: "text",
  placeholder: "Please select a state in Malaysia!",
  disabled: ""
}
const _hoisted_113 = ["disabled"]
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, [
  /*#__PURE__*/_createTextVNode("Postal Code "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */))
const _hoisted_116 = ["disabled"]
const _hoisted_117 = { class: "form-group d-flex mt-8" }
const _hoisted_118 = ["disabled"]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agreement",
  class: "agreement-label"
}, [
  /*#__PURE__*/_createTextVNode("By ticking this box, you consent to abide by the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: `/terms-and-conditions`,
    target: "_blank",
    style: {"color":"#6b68ff","text-decoration":"underline"}
  }, "Terms and Conditions"),
  /*#__PURE__*/_createTextVNode(" as well as "),
  /*#__PURE__*/_createElementVNode("a", {
    href: `/privacy-policy`,
    target: "_blank",
    style: {"color":"#6b68ff","text-decoration":"underline"}
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" outlined herein. Please review the terms carefully before proceeding. Your acceptance indicates your understanding and agreement to be bound by these terms.")
], -1 /* HOISTED */))
const _hoisted_120 = {
  style: {"font-size":"0.875rem"},
  class: "form-error-msg"
}
const _hoisted_121 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_122 = { class: "form-actions" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { style: {"text-align":"center","margin-top":"2rem","color":"#398bff","font-size":"14px"} }
const _hoisted_125 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Select = _resolveComponent("Select")

  return ($data.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          ($data.isExpired)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _createTextVNode(" This link has expired."),
                _hoisted_5,
                _createTextVNode(" If you have any concern, please contact us at "),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("a", {
                    href: `mailto:${$data.support_email_address}`
                  }, _toDisplayString($data.support_email_address), 9 /* TEXT, PROPS */, _hoisted_7)
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" Invalid session link."),
                _hoisted_9,
                _createTextVNode(" If you have any concern, please contact us at "),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("a", {
                    href: `mailto:${$data.support_email_address}`
                  }, _toDisplayString($data.support_email_address), 9 /* TEXT, PROPS */, _hoisted_11)
                ])
              ]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: $data.logo_file_path,
            alt: "Logo",
            style: {"width":"9rem","margin":"1rem"}
          }, null, 8 /* PROPS */, _hoisted_14),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          ($data.isSubmitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [..._hoisted_20]))
            : _createCommentVNode("v-if", true),
          _hoisted_21,
          _createElementVNode("form", {
            onSubmit: _cache[29] || (_cache[29] = _withModifiers((...args) => ($options.submitForm && $options.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.formData.voucher_no) = $event)),
                placeholder: "POS Invoice No",
                disabled: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.formData.voucher_no]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.formData.date) = $event)),
                placeholder: "Date",
                disabled: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.formData.date]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.formData.store_name) = $event)),
                placeholder: "Store Name",
                disabled: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $data.formData.store_name]
              ])
            ]),
            _hoisted_28,
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.formData.full_name) = $event)),
                placeholder: "e.g. Syatifah binti Ibrahim",
                required: "",
                disabled: $data.isSubmitted
              }, null, 8 /* PROPS */, _hoisted_32), [
                [_vModelText, $data.formData.full_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                id: "email-field",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.formData.email_address) = $event)),
                placeholder: "e.g. syatifah@gmail.com",
                required: "",
                disabled: $data.isSubmitted
              }, null, 8 /* PROPS */, _hoisted_35), [
                [_vModelText, $data.formData.email_address]
              ]),
              _createElementVNode("div", _hoisted_36, [
                ($data.form_error_data.email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($data.form_error_data.email), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("input", {
                id: "phone",
                type: "tel",
                disabled: $data.isSubmitted,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_40),
              _createElementVNode("div", _hoisted_41, [
                ($data.form_error_data.phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString($data.form_error_data.phone), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "customer_type",
                  value: "Individual",
                  id: "individual",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.formData.customer_type) = $event)),
                  required: "",
                  disabled: $data.isSubmitted,
                  checked: $data.formData.customer_type === 'Individual'
                }, null, 8 /* PROPS */, _hoisted_46), [
                  [_vModelRadio, $data.formData.customer_type]
                ]),
                _hoisted_47
              ]),
              _createElementVNode("div", _hoisted_48, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "customer_type",
                  value: "Company",
                  id: "company",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.formData.customer_type) = $event)),
                  required: "",
                  disabled: $data.isSubmitted,
                  checked: $data.formData.customer_type === 'Company'
                }, null, 8 /* PROPS */, _hoisted_49), [
                  [_vModelRadio, $data.formData.customer_type]
                ]),
                _hoisted_50
              ])
            ]),
            _hoisted_51,
            ($data.formData.customer_type)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_52))
              : _createCommentVNode("v-if", true),
            ($data.formData.customer_type === 'Individual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "identification_number_type",
                        value: "MyKad",
                        id: "NRIC",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.formData.identification_number_type) = $event)),
                        required: "",
                        disabled: $data.isSubmitted,
                        checked: $data.formData.identification_number_type === 'MyKad'
                      }, null, 8 /* PROPS */, _hoisted_59), [
                        [_vModelRadio, $data.formData.identification_number_type]
                      ]),
                      _hoisted_60
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "identification_number_type",
                        id: "Passport",
                        value: "Passport",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.formData.identification_number_type) = $event)),
                        required: "",
                        disabled: $data.isSubmitted,
                        checked: $data.formData.identification_number_type === 'Passport'
                      }, null, 8 /* PROPS */, _hoisted_62), [
                        [_vModelRadio, $data.formData.identification_number_type]
                      ]),
                      _hoisted_63
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "identification_number_type",
                        id: "Army",
                        value: "MyTentera",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.formData.identification_number_type) = $event)),
                        required: "",
                        disabled: $data.isSubmitted,
                        checked: $data.formData.identification_number_type === 'MyTentera'
                      }, null, 8 /* PROPS */, _hoisted_65), [
                        [_vModelRadio, $data.formData.identification_number_type]
                      ]),
                      _hoisted_66
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      onInput: _cache[10] || (_cache[10] = (...args) => ($options.ignore_dash_character && $options.ignore_dash_character(...args))),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.formData.identification_number) = $event)),
                      placeholder: $options.getPlaceholder($data.formData.identification_number_type),
                      required: $data.formData.identification_number_type,
                      disabled: $data.isSubmitted || $data.formData.identification_number_type === '',
                      id: "identification_number"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_68), [
                      [_vModelText, $data.formData.identification_number]
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      ($data.form_error_data.identification_number)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString($data.form_error_data.identification_number), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      onInput: _cache[12] || (_cache[12] = (...args) => ($options.ignore_dash_character && $options.ignore_dash_character(...args))),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.formData.individual_tin) = $event)),
                      placeholder: "e.g. C1212341234",
                      disabled: $data.isSubmitted,
                      id: "individual_tin",
                      required: ""
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_73), [
                      [_vModelText, $data.formData.individual_tin]
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      ($data.form_error_data.individual_tin)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString($data.form_error_data.individual_tin), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : ($data.formData.customer_type === 'Company')
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _hoisted_77,
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.formData.company_name) = $event)),
                        placeholder: "e.g. Coffee Shop Sdn. Bhd.",
                        required: "",
                        disabled: $data.isSubmitted
                      }, null, 8 /* PROPS */, _hoisted_81), [
                        [_vModelText, $data.formData.company_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onInput: _cache[15] || (_cache[15] = (...args) => ($options.ignore_dash_character && $options.ignore_dash_character(...args))),
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($data.formData.company_id) = $event)),
                        placeholder: "e.g. 201909123456",
                        required: "",
                        disabled: $data.isSubmitted,
                        id: "company_id"
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_84), [
                        [_vModelText, $data.formData.company_id]
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        ($data.form_error_data.company_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString($data.form_error_data.company_id), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onInput: _cache[17] || (_cache[17] = (...args) => ($options.ignore_dash_character && $options.ignore_dash_character(...args))),
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($data.formData.company_tin) = $event)),
                        placeholder: "e.g. C1212341234",
                        disabled: $data.isSubmitted,
                        id: "company_tin",
                        required: ""
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_89), [
                        [_vModelText, $data.formData.company_tin]
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        ($data.form_error_data.company_tin)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString($data.form_error_data.company_tin), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _hoisted_93,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onInput: _cache[19] || (_cache[19] = (...args) => ($options.ignore_dash_character && $options.ignore_dash_character(...args))),
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($data.formData.sst_number) = $event)),
                        placeholder: "e.g. X89-2104-12345678",
                        disabled: $data.isSubmitted,
                        id: "company_sst_number"
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_94), [
                        [_vModelText, $data.formData.sst_number]
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        ($data.form_error_data.company_sst_number)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString($data.form_error_data.company_sst_number), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (($data.formData.address_line_1) = $event)),
                placeholder: "e.g. Unit No, Street Name",
                disabled: $data.isSubmitted,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_99), [
                [_vModelText, $data.formData.address_line_1]
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _hoisted_101,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($data.formData.address_line_2) = $event)),
                placeholder: "e.g. Unit No, Street Name",
                disabled: $data.isSubmitted
              }, null, 8 /* PROPS */, _hoisted_102), [
                [_vModelText, $data.formData.address_line_2]
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _hoisted_104,
              _createVNode(_component_Select, {
                "pt:root:class": "w-100",
                disabled: $data.isSubmitted,
                modelValue: $data.formData.country,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($data.formData.country) = $event)),
                options: $data.countries_list,
                filter: "",
                optionLabel: "name",
                optionValue: "name",
                placeholder: "Select a Country",
                class: "w-full md:w-56"
              }, null, 8 /* PROPS */, ["disabled", "modelValue", "options"])
            ]),
            ($data.formData.country === 'Malaysia')
              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                  _hoisted_106,
                  _createVNode(_component_Select, {
                    "pt:root:class": "w-100",
                    disabled: $data.isSubmitted,
                    modelValue: $data.formData.state,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($data.formData.state) = $event)),
                    options: $options.filteredStateOptions,
                    filter: "",
                    optionLabel: "state",
                    optionValue: "name",
                    placeholder: "Select a State",
                    class: "w-full md:w-56"
                  }, null, 8 /* PROPS */, ["disabled", "modelValue", "options"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_107, [
              ($data.formData.country)
                ? (_openBlock(), _createElementBlock("label", _hoisted_108, [
                    _createTextVNode("City "),
                    _hoisted_109
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode("State is not applicable and country is Malaysia"),
              ($data.formData.state !== '' && $data.formData.state !== '17' && $data.formData.country === 'Malaysia')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($data.formData.city) = $event)),
                    class: _normalizeClass({ 'select_background_white': !$data.isSubmitted, 'select_background_grey': $data.isSubmitted }),
                    required: "",
                    disabled: $data.isSubmitted
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cities(), (city, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: city
                      }, _toDisplayString(city), 9 /* TEXT, PROPS */, _hoisted_111))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 10 /* CLASS, PROPS */, _hoisted_110)), [
                    [_vModelSelect, $data.formData.city]
                  ])
                : (($data.formData.state === '' || $data.formData.state === '17') && $data.formData.country === 'Malaysia')
                  ? (_openBlock(), _createElementBlock("input", _hoisted_112))
                  : ($data.formData.state === '17' && $data.formData.country !== 'Malaysia')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 3,
                        type: "text",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => (($data.formData.city) = $event)),
                        required: "",
                        disabled: $data.isSubmitted,
                        placeholder: "e.g. New York"
                      }, null, 8 /* PROPS */, _hoisted_113)), [
                        [_vModelText, $data.formData.city]
                      ])
                    : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_114, [
              _hoisted_115,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "postal_code",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (($data.formData.postal_code) = $event)),
                placeholder: "e.g. 43200",
                required: "",
                disabled: $data.isSubmitted
              }, null, 8 /* PROPS */, _hoisted_116), [
                [_vModelText, $data.formData.postal_code]
              ])
            ]),
            _createElementVNode("div", _hoisted_117, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "agreement",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($data.formData.accept_privacy_policy_and_tac) = $event)),
                required: "",
                disabled: $data.isSubmitted
              }, null, 8 /* PROPS */, _hoisted_118), [
                [_vModelCheckbox, $data.formData.accept_privacy_policy_and_tac]
              ]),
              _hoisted_119,
              _createElementVNode("div", _hoisted_120, [
                ($data.form_error_data.agreement)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString($data.form_error_data.agreement), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["btn-primary", { 'btn-success': $data.isSubmitted }]),
                disabled: $data.isSubmitting || $data.isSubmitted,
                style: {"border-radius":"2rem","font-weight":"bold"}
              }, _toDisplayString($data.isSubmitted ? "Submitted" : ($data.isSubmitting ? "Submitting..." : "Submit")), 11 /* TEXT, CLASS, PROPS */, _hoisted_123)
            ])
          ], 32 /* NEED_HYDRATION */),
          _createElementVNode("div", _hoisted_124, [
            _createTextVNode(" Powered by "),
            _createElementVNode("a", {
              href: `https://www.byondwave.com/`,
              target: "_blank",
              style: {"color":"#398bff"}
            }, "BYONDWAVE.com", 8 /* PROPS */, _hoisted_125)
          ])
        ])
      ]))
}